var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33496 8.00002C1.33496 4.31865 4.31859 1.33502 7.99996 1.33502C11.6813 1.33502 14.665 4.31865 14.665 8.00002C14.665 11.6814 11.6813 14.665 7.99996 14.665C4.31859 14.665 1.33496 11.6814 1.33496 8.00002ZM11.0148 6.84927C11.2986 6.56549 11.2986 6.10206 11.0148 5.81828C10.731 5.53449 10.2676 5.53449 9.98384 5.81828L7.16684 8.63528L6.01608 7.48453C5.7323 7.20074 5.26887 7.20074 4.98509 7.48453C4.70131 7.76831 4.70131 8.23173 4.98509 8.51552L6.65134 10.1818C6.93512 10.4656 7.39855 10.4656 7.68233 10.1818L11.0148 6.84927Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f1268aa7efb598e110e89594c79d146a.svg";
export { ForwardRef as ReactComponent };